import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '亚洲无码正版内容平台推荐指南',
    url: 'https://shakea1.cn',
    description: '致力于为中文用户提供亚洲无码正版内容平台的客观推荐与合规观看指南。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@shakea1.cn',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-16">
          <header className="mb-12">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              关于我们
            </h1>
            <p className="text-sm text-foreground-600 leading-relaxed">
              亚洲无码正版内容平台推荐指南 — 致力于为中文用户提供客观、专业的正版平台推荐与合规观看指导。
            </p>
          </header>

          <section className="mb-12" aria-labelledby="brand-intro">
            <h2 id="brand-intro" className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              <a href="#brand-intro">品牌介绍</a>
            </h2>
            <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
              <p>
                亚洲无码正版内容平台推荐指南成立于2024年，是国内最早专注于亚洲无码正版内容平台推荐与合规教育的专业信息平台之一。
                我们致力于帮助成年用户在合法、安全的前提下获取高质量的亚洲无码影音资源。
              </p>
              <p>
                我们的团队由资深行业观察者、法律顾问和内容编辑组成，持续追踪亚洲各国成人内容市场的最新动态，
                为用户提供全面、客观、及时的平台评测和观看指南。我们坚持独立运营，不接受任何平台的付费推广，
                确保推荐内容的公正性和可信度。
              </p>
              <p>
                在信息服务之外，我们积极参与成人内容消费的合规教育，倡导版权保护意识，
                推动行业朝着更加规范、透明的方向发展。我们相信，合法合规的内容消费不仅保护用户权益，
                也是对内容创作者劳动成果的尊重。
              </p>
            </div>
          </section>

          <section className="mb-12" aria-labelledby="reputation">
            <h2 id="reputation" className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              <a href="#reputation">行业信誉</a>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="bg-background-100/70 rounded-xl p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="w-6 h-6 flex items-center justify-center text-accent-600">
                    <i className="ri-shield-check-line text-lg"></i>
                  </span>
                </div>
                <div className="font-heading font-semibold text-2xl text-foreground-900 mb-1">50+</div>
                <p className="text-xs text-foreground-600">评测平台数量</p>
              </div>
              <div className="bg-background-100/70 rounded-xl p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-600">
                    <i className="ri-article-line text-lg"></i>
                  </span>
                </div>
                <div className="font-heading font-semibold text-2xl text-foreground-900 mb-1">200+</div>
                <p className="text-xs text-foreground-600">原创文章</p>
              </div>
              <div className="bg-background-100/70 rounded-xl p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <span className="w-6 h-6 flex items-center justify-center text-secondary-600">
                    <i className="ri-user-heart-line text-lg"></i>
                  </span>
                </div>
                <div className="font-heading font-semibold text-2xl text-foreground-900 mb-1">50万+</div>
                <p className="text-xs text-foreground-600">月均访问用户</p>
              </div>
            </div>
          </section>

          <section className="mb-12" aria-labelledby="disclaimer">
            <h2 id="disclaimer" className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              <a href="#disclaimer">免责声明</a>
            </h2>
            <div className="space-y-3 text-sm text-foreground-700 leading-relaxed bg-background-100/70 rounded-xl p-5">
              <p>
                本站为信息聚合与推荐平台，所有推荐的平台均为第三方运营。本站不提供任何内容的存储、播放或下载服务。
              </p>
              <p>
                本站所有内容仅供18岁以上成年用户参考。未成年人请勿浏览本站。用户在使用本站推荐的第三方平台时，
                应自行遵守当地法律法规，并对自身行为负责。
              </p>
              <p>
                本站对推荐的第三方平台内容不承担任何法律责任。如发现任何平台存在违规行为，请通过联系方式通知我们，
                我们将及时进行核实和处理。
              </p>
            </div>
          </section>

          <section aria-labelledby="contact">
            <h2 id="contact" className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              <a href="#contact">联系我们</a>
            </h2>
            <div className="bg-background-100/70 rounded-xl p-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-sm">
                <div className="flex items-start gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </span>
                  <div>
                    <p className="font-medium text-foreground-900 mb-0.5">电子邮件</p>
                    <p className="text-foreground-600">contact@shakea1.cn</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </span>
                  <div>
                    <p className="font-medium text-foreground-900 mb-0.5">工作时间</p>
                    <p className="text-foreground-600">周一至周五 9:00-18:00 (GMT+8)</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </main>
      <Footer />
    </>
  );
}